import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import { translationResource } from 'src/assets/locales';

i18n.use(initReactI18next).init({
  debug: false,
  fallbackLng: 'pt-BR',
  interpolation: {
    escapeValue: false,
  },
  resources: translationResource,
});

export default i18n;
